import {
	Component,
	Input,
	OnInit,
	OnDestroy,
	OnChanges,
	SimpleChanges,
	Output,
	EventEmitter,
	ViewChild,
	ElementRef,
	AfterViewInit,
	ViewEncapsulation
} from "@angular/core";
import { IdService } from "../shared/services/id.service";

import { Subscription } from "rxjs";
import { SidenavService } from "./sidenav.service";
import { ActivatedRouteSnapshot } from "@angular/router";
import { ISidenavEvent } from "./sidenav.types";
import { SideNavItem } from "./sidenav.interface";

@Component({
	selector: "rbc-side-nav",
	templateUrl: "./sidenav.component.html",
	encapsulation: ViewEncapsulation.None,
	providers: [SidenavService]
})
export class SidenavComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	// @Input() currentPage: {};

	@Input()
	get toggled(): boolean {
		return this._navIsToggled;
	}
	set toggled(val: boolean) {
		this._navIsToggled = val;
		this.hamburgerIsToggled = this.toggled;
		this.toggleLinks(this.hamburgerIsToggled);
	}

	@Input() id: string;
	@Input() currentPage: ActivatedRouteSnapshot;
	@Input() search: boolean | Function;
	@Input() searchPlaceholder = "Search";
	@Input() searchLabel = "Search";
	@Input() arrows = true;
	@Input() hamburgerPositionX: "left" | "right" = "left";
	@Input() toggleType: "icon" | "full" = "full";
	@Input() fullWidth = true;
	@Input() items: SideNavItem[];
	@Input() anchorLinks: [];

	@Output() onSearch = new EventEmitter<any>();
	@Output() navtoggleupdate: EventEmitter<ISidenavEvent> = new EventEmitter<ISidenavEvent>();
	@Output() navexpandupdate = new EventEmitter<any>();


	@ViewChild("sideNav", { static: false }) sideNav: ElementRef;
	@ViewChild("mobileTopSlot", { static: false }) mobileTopSlot: ElementRef;
	@ViewChild("otherSlot", { static: false }) otherSlot: ElementRef;
	@ViewChild("mobileBottomSlot", { static: false }) mobileBottomSlot: ElementRef;

	// @ContentChildren(SidenavItemComponent) items: QueryList<SidenavItemComponent>;

	_navIsToggled = false;
	active = { expand: null };
	currentPageLocal: { name: "" };
	// hamburgerIsToggled = false;
	isMd = true;
	query = "";

	get isDisabledNavigation(): boolean {
		return (!this.isMd && this.toggleType && this.toggleType !== "icon" && this.hamburgerIsToggled) ||
			(this.isMd && !this.hamburgerIsToggled);
	}

	_hamburgerIsToggled = false;
	get hamburgerIsToggled(): boolean {
		return this._hamburgerIsToggled;
	}
	set hamburgerIsToggled(val: boolean) {
		this._hamburgerIsToggled = val;
		// toggle nav if body is clicked on smaller screens
		if (window.matchMedia("(max-width: 991px)").matches) {
			// attach some handlers and invert control of their detachment
			const bodyClick = ["click", "touchend"].map(eventName => {
				const handler = this.toggleLinksMobile.bind(this);
				document.body.addEventListener(eventName, handler);
				return () => document.body.removeEventListener(eventName, handler);
			});
			// detach all handlers in one call with intact refs
			if (!this.hamburgerIsToggled) {
				bodyClick.forEach(d => d());
			}
		}
	}

	$eventBusSub: Subscription;

	constructor(private idService: IdService, private sidenavService: SidenavService) { }

	ngOnInit() {
		this.id = this.id ? this.id : this.idService.generate();
		this.isMd = window.matchMedia("(max-width: 991px)").matches;

		if (!this.searchPlaceholder) {
			this.searchPlaceholder = "Search";
		}

		this.mountEventBus();
		this.sidenavService.setParent(this);
	}


	arrayOne(n: number): any[] {
		return Array(n);
	}


	mountEventBus() {
		this.$eventBusSub = this.sidenavService.$eventBus.subscribe(event => {
			if (event.isDirectChild && event.activeItemId && this.sidenavService.itemsFlat[event.activeItemId]) {
				// set the new active link or expand by broadcasting new active to all subscribers
				this.sidenavService.$activeItemId.next(event.activeItemId);
			}

			// ensure that the nav re-hides when link is selected on smaller screens
			// ...or if expand is selected on larger screens
			if (
				(!event.item.expandable && event.item.router && this.isMd) ||
				(event.item.expandable && this.hamburgerIsToggled && !this.isMd)
			) {
				this.toggleLinks(false);
				// pass nav toggle state up to parent
				this.navtoggleupdate.emit({ isToggled: false, self: this });
			}
		});
	}

	asElement(element: Element): HTMLElement {
		return element as HTMLElement;
	}

	ngAfterViewInit() {
		// cleanup view
		if (!this.asElement(this.mobileTopSlot.nativeElement).children.length && !this.search) {
			this.asElement(this.mobileTopSlot.nativeElement).remove();
		}
		if (!this.asElement(this.otherSlot.nativeElement).children.length) {
			this.asElement(this.otherSlot.nativeElement).remove();
		}
		if (!this.asElement(this.mobileBottomSlot.nativeElement).children.length) {
			this.asElement(this.mobileBottomSlot.nativeElement).remove();
		}

		// get the corresponding sidenav item to a provided currentPage object
		this.getCurrentPageKey();

		// add classes to the body to properly style content and top nav
		// add default side nav class to body
		if (this.toggleType) {
			const navClass = this.toggleType === "icon" ? "nav-collapsable-icon" : "nav-collapsable";
			document.body.classList.add(navClass);
			document.body.classList.add("nav-is-default");
		}

		// add right nav class if the hamburger is to the right
		if (this.hamburgerPositionX === "right") {
			document.body.classList.add("nav-right");
		}

		this.navtoggleupdate.emit({ isToggled: this.hamburgerIsToggled, self: this });
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes) {
			if (changes.currentPage) {
				this.getCurrentPageKey();
			}
		}
	}

	ngOnDestroy() {
		if (this.idService) {
			this.idService.remove(this.id);
		}
		if (this.$eventBusSub) {
			this.$eventBusSub.unsubscribe();
		}
	}

	toggleLinks(toggled: boolean) {
		this.hamburgerIsToggled = toggled === true || toggled === false ? toggled : !this.hamburgerIsToggled;
		const body = document.body;

		// add / remove classes to the body depending if nav is open or closed
		if (this.hamburgerIsToggled) {
			body.classList.add("nav-is-toggled");
			if (this.toggleType) {
				body.classList.remove("nav-is-default");
			}
		} else {
			body.classList.remove("nav-is-toggled");
			if (this.toggleType) {
				body.classList.add("nav-is-default");
			}
		}
		// close all Expandables if the nav is toggled on larger screens
		if (this.hamburgerIsToggled && !this.isMd && this.toggleType === 'icon') {
			this.active["expand"] = "";

		}

		const isMd = window.matchMedia("(max-width: 991px)").matches;

		// close all Expandables if the nav is toggled on larger screens
		if (this.hamburgerIsToggled && !isMd && this.toggleType === "icon") {
			this.sidenavService.closeAllItems();
		}

		// let everyone know the nav toggle state
		this.navtoggleupdate.emit({ isToggled: this.hamburgerIsToggled, self: this });
	}

	toggleLinksMobile(e) {
		if (e.target.classList.contains("nav-is-toggled")) {
			this.toggleLinks(false);
		}
	}

	emitSearch(searchEvent) {
		this.onSearch.emit(searchEvent);
	}

	$_SideNav_search() {
		if (typeof this.search === "function") {
			this.search(this.query);
		}
	}

	setActiveExpand(itemId: string) {
		// set the active.expand if the link is an expandable
		if (itemId && this.sidenavService.itemsFlat[itemId].expandable) {
			this.sidenavService.$activeItemId.next(itemId);
		}
	}

	getCurrentPageKey() {
		// get and save the id of the current page expandable
		if (this.currentPage) {
			const currentPageKey = this.sidenavService.findMatchingItemForRoute(this.currentPage);
			// NOTE: only the first matched segment is used, which means the highest expandable item is automatically expanded
			this.setActiveExpand(currentPageKey);
		}
	}

	isVisible(item) {
		return typeof item.visible === "undefined";
	}
}
